import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/auth/auth.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser'; // Import DomSanitizer
import { faUserLock } from '@fortawesome/pro-regular-svg-icons';

@Component({
  selector: 'app-logout-modal',
  templateUrl: './logout-modal.component.html',
  standalone: false,
  styleUrl: './logout-modal.component.scss'
})
export class LogoutModalComponent implements OnInit {

  public showAlert: boolean=false;
   icons = {
    faUserLock
  };

 constructor(private sanitizer: DomSanitizer,private router: Router, private _auth: AuthService, @Inject(MAT_DIALOG_DATA) public data: any,) { }

 safeHtmlContent!: SafeHtml; // To hold the sanitized message
  ngOnInit(): void {

     if (this.router.url === '/domain-error') {

      this.showAlert=false;

     }
     else{

      this.showAlert=true;;
     }
    this.safeHtmlContent = this.sanitizeHtml(this.data.value);
  }

  sanitizeHtml(html: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  loginAction() {
    this._auth.changeMessage('default message');
    this.router.navigate(['/authcheck'],{ state: { incomingFromApp: true } });
  }
}
